import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { ReceiptsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createReceipt = (data): any => action(types.CREATE_RECEIPT_REQUESTED, data);

export const updateReceipt = (data): any => action(types.UPDATE_RECEIPT_REQUESTED, data);

export const deleteReceipt = (receiptId): any => action(types.UPDATE_RECEIPT_REQUESTED, receiptId);

export const getReceipt = (receiptId): any => action(types.GET_RECEIPT_REQUESTED, receiptId);

export const getAllReceipts = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_RECEIPTS_REQUESTED, { pagination, compile });

export const selectReceipt = (receiptId): any => action(types.SELECT_RECEIPT_REQUESTED, {
  currentReceiptId: receiptId,
});

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createReceiptPending: (payload): any => action(types.CREATE_RECEIPT_PENDING, payload),
  createReceiptSuccess: (response): any => action(types.CREATE_RECEIPT_SUCCESS, {
    receiptsById: response.entities.receipts,
    currentReceiptId: response.result,
  }),
  updateReceiptPending: (payload): any => action(types.UPDATE_RECEIPT_PENDING, payload),
  updateReceiptSuccess: (response): any => action(types.UPDATE_RECEIPT_SUCCESS, {
    receiptsById: response.entities.receipts,
    currentReceiptId: response.result,
  }),
  updateReceiptFailed: (error): any => action(types.UPDATE_RECEIPT_FAIL, { backendErrors: error }),
  deleteReceiptPending: (): any => action(types.UPDATE_RECEIPT_PENDING, {}),
  deleteReceiptSuccess: (response, userId): any => {
    localStorage.set(userId, { currentReceiptId: null });
    history.push('/receipts');

    return action(types.DELETE_RECEIPT_SUCCESS, {
      currentReceiptId: response,
    });
  },
  getReceiptPending: (): any => action(types.GET_RECEIPT_PENDING, {}),
  getReceiptSuccess: (response): any => action(types.GET_RECEIPT_SUCCESS, {
    receiptsById: response.entities.receipts,
    currentReceiptId: response.result,
  }),
  getReceiptFailed: (error): any => action(types.GET_RECEIPT_FAIL, { backendErrors: error }),
  deleteReceiptFailed: (error): any => action(types.UPDATE_RECEIPT_FAIL, { backendErrors: error }),
  getAllReceiptsPending: (pagination): any => action(types.GET_ALL_RECEIPTS_PENDING, { pagination }),
  getAllReceiptsSuccess: (response, meta): any => action(types.GET_ALL_RECEIPTS_SUCCESS, {
    receiptsById: response.entities.receipts,
    receiptIds: response.result,
    meta,
  }),
  getAllReceiptsFailed: (error): any => action(types.GET_ALL_RECEIPTS_FAIL, { backendErrors: error }),
  createReceiptFailed: (error): any => action(types.CREATE_RECEIPT_FAIL, { backendErrors: error }),
};

export default null;
